import { cssVar } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

interface SelectorContainerProps {
  active: boolean;
}

export const SelectorContainer = styled.div<SelectorContainerProps>`
  border-top: 4px solid ${cssVar('gray-light-100')};
  transition: border-color 0.2s ease-in-out;

  &:hover {
    border-color: ${cssVar('border-brand')};
  }

  ${({ active }) =>
    active &&
    css`
      border-color: ${cssVar('border-brand')};
    `}
`;
